import { createTheme } from "@mui/material/styles";
import { GothamBook, CopernicusBook, CopernicusBookItalic, GothamBlack, GothamBold } from "./themeFonts";

const hublotTheme = createTheme({
    typography: {
        fontFamily: [
            '"Gotham Book"',
            '"Galaxie Copernicus"',
            "Verdana",
            "Arial",
            "Helvetica",
            "sans-serif",
        ].join(","),
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
            @font-face {
                font-family: 'Gotham Book';
                font-style: normal;
                src: local('Gotham Book'), url(${GothamBook});
            }
            @font-face {
                font-family: 'Gotham Book';
                font-style: normal;
                font-weight: 450;
                src: local('Gotham Book'), url(${GothamBlack});
            }
            @font-face {
                font-family: 'Gotham Book';
                font-style: normal;
                font-weight: 410;
                src: local('Gotham Book'), url(${GothamBold});
            }
            @font-face {
                font-family: 'Galaxie Copernicus';
                font-style: normal;
                src: url(${CopernicusBook});
            }
            @font-face {
                font-family: 'Galaxie Copernicus';
                font-style: italic;
                src: url(${CopernicusBookItalic});
            }
            `,
        },
    },
});

export default hublotTheme;
